
        Component.define('header', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

$('.btn-menu-mobile', el).on('click', function(e){
    $(this).toggleClass('btn-mobile-active');
    $(el).toggleClass('active');
    $('html, body, main').toggleClass('page-overflow-hidden');
    $('html').toggleClass('menu-opened');
});


$('ul li a', el).on('click', function(){
    if ($('.btn-menu-mobile').is(':visible')){
        $('.btn-menu-mobile', el).trigger('click');
    }
});
        });